import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { ColoredTableOuter, ColoredTableItem, ColoredTableHead, ColoredTableBody, ColoredTableSubject } from './color-table'

const Outer = styled.div`
  margin-top: 2rem;
`

const Text = styled.div`
  font-weight: 700;
  line-height: 2;
  margin-bottom: 2rem;
`

type ImageSectionProps = {

}
export const ImageSection: FunctionComponent<ImageSectionProps> = () => {
  return <Outer>
    <Text>ムロノキッズでは、たくさんの先生が、さまざまな働き方で、子どもたちと自分自身を育てています。</Text>
    <ColoredTableOuter style={{'--columns': 4}}>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#00b2cc'}}>
          3年目
        </ColoredTableHead>
        <ColoredTableBody>
          <ColoredTableSubject>幼稚園年中クラス担任</ColoredTableSubject>
          1年目は年少フリー、2年目は1歳児クラス担当として、先輩たちから1日の流れや仕事を学び、3年目は年中クラス担任にステップアップ！
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#9d92c1'}}>
          6年目
        </ColoredTableHead>
        <ColoredTableBody>
          <ColoredTableSubject>プリスクール０歳児クラス担任</ColoredTableSubject>
          乳児から年長クラスまで一通り経験。一人ひとりの子どもに目を配ることができるように。やっと保育園・幼稚園の先生として一人前！
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#ed8599'}}>
          8年目
        </ColoredTableHead>
        <ColoredTableBody>
          担任バスクラスの補助
          <ColoredTableSubject>英語クラスリーダー</ColoredTableSubject>
          先生たちのまとめ役。新人の指導も担当。園児全員を把握し、保育活動が円滑に行われるように配慮します。
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#eea76e'}}>
          復帰2年目
        </ColoredTableHead>
        <ColoredTableBody>
          <ColoredTableSubject>学童保育クラス担当</ColoredTableSubject>
          クラス担任を7年勤め、結婚・出産のため一時退職。復帰後も子育ての経験を生かして、パートタイムでの勤務も可能です。
        </ColoredTableBody>
      </ColoredTableItem>
    </ColoredTableOuter>
  </Outer>
}